import {
  Home,
  TrendingUp,
  PiggyBank,
  Send,
  Users,
  ShoppingBag,
  ArrowLeftRight,
  Wallet,
  CreditCard,
  RotateCw,
} from 'lucide-react';

import { config, type ProductStatus } from '@tankef/env';
import { useTranslation } from '@tankef/i18n';
import type { NavGroupData, NavItemData } from '@tankef/ui';

const comingSoonBadge = (
  <span className="rounded-full bg-tkf-surface-muted px-2 py-0.5 text-[10px] font-semibold text-tkf-fg-muted">
    Próx.
  </span>
);

function productItem(
  key: string,
  title: string,
  path: string,
  icon: React.ReactNode,
  status: ProductStatus
): NavItemData | null {
  if (status === 'disabled') return null;
  return {
    key,
    title,
    path,
    icon,
    // fake_door: visible a color pleno (no gris) con badge "Próx.", pero la ruta
    // sigue inactiva (disabled). Solo cambia el color; mismo comportamiento.
    ...(status === 'fake_door' ? { disabled: true, dimmed: false, info: comingSoonBadge } : {}),
  };
}

export function useNavData(): NavGroupData[] {
  const { t } = useTranslation('common');
  const { products, productsCatalogEnabled } = config;

  const productItems = [
    {
      key: 'wallet',
      title: t('navigation.wallet'),
      path: '/wallet',
      icon: <Wallet className="h-5 w-5" />,
    },
    productItem(
      'investments',
      t('navigation.investments'),
      '/investments',
      <TrendingUp className="h-5 w-5" />,
      products.investment
    ),
    productItem(
      'savings-box',
      t('navigation.savingsBox'),
      '/savings-box',
      <PiggyBank className="h-5 w-5" />,
      products.savings_box
    ),
    productItem(
      'tandas',
      t('navigation.tandas'),
      '/tandas',
      <RotateCw className="h-5 w-5" />,
      products.tanda
    ),
    productItem(
      'credits',
      t('navigation.credits'),
      '/credits',
      <CreditCard className="h-5 w-5" />,
      products.credit
    ),
  ].filter((item): item is NavItemData => item !== null);

  return [
    {
      subheader: t('navigation.sectionHome'),
      items: [
        {
          key: 'dashboard',
          title: t('navigation.home'),
          path: '/dashboard',
          icon: <Home className="h-5 w-5" />,
        },
      ],
    },
    {
      subheader: t('navigation.operar'),
      items: [
        {
          key: 'transfer',
          title: t('navigation.transfers'),
          path: '/transfer',
          icon: <ArrowLeftRight className="h-5 w-5" />,
        },
        {
          key: 'payments',
          title: t('navigation.payments'),
          path: '/payments',
          icon: <Send className="h-5 w-5" />,
        },
        {
          key: 'contacts',
          title: t('navigation.contacts'),
          path: '/contacts',
          icon: <Users className="h-5 w-5" />,
        },
      ],
    },
    {
      subheader: t('navigation.misProductos'),
      items: productItems,
    },
    ...(productsCatalogEnabled
      ? [
          {
            subheader: t('navigation.explorar'),
            items: [
              {
                key: 'products',
                title: t('navigation.products'),
                path: '/products',
                icon: <ShoppingBag className="h-5 w-5" />,
              },
            ],
          },
        ]
      : []),
  ];
}
